import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { F_NUM } from 'assets/FormatNumbers'
import { searchUser, select } from 'types/SearchTypes'

type searchUserState = {
  searchJoken: searchUser // 検索条件
  openModal: boolean // モーダル表示判定
  tokuiLabel: select[] // 得意先一覧
  tenpoLabel: select[] // 店舗一覧
}

const initialState: searchUserState = {
  searchJoken: {
    // 検索条件
    JIGYO_CD: F_NUM, // 事業所コード
    MAIL: String(F_NUM), // メールアドレス
    inclideKari: false, // 仮登録ユーザー
    TOKUI_CD: F_NUM, // 得意先コード
    TEN_CD: F_NUM, // 店舗コード
  },
  openModal: false, // モーダル表示判定
  tokuiLabel: [], // 得意先一覧
  tenpoLabel: [], // 店舗一覧
}
export const searchUserSlice = createSlice({
  name: 'searchJoken',
  initialState: initialState,
  reducers: {
    // 事業所変更 //===========================//
    changeJigyoCd: (state, action: PayloadAction<select>) => {
      if (action.payload != null) {
        state.searchJoken.JIGYO_CD = parseInt(action.payload.value)
      }
    },
    // メールアドレス変更 //===========================//
    changeMail: (state, action: PayloadAction<select>) => {
      if (action.payload != null) {
        state.searchJoken.MAIL = action.payload.value
      }
    },
    // メールアドレス変更 //===========================//
    changeInclideKari: (state, action: PayloadAction<boolean>) => {
      state.searchJoken.inclideKari = action.payload
    },
    // 得意先変更 //===========================//
    changeTokuiCd: (state, action: PayloadAction<select>) => {
      if (action.payload != null) {
        state.searchJoken.TOKUI_CD = parseInt(action.payload.value)
      }
    },
    // 店舗変更 //===========================//
    changeTenCd: (state, action: PayloadAction<select>) => {
      if (action.payload != null) {
        state.searchJoken.TEN_CD = parseInt(action.payload.value)
      }
    },
    // 初期状態に設定する処理 //===========================//
    initialize: (state, action: PayloadAction<{ isSuper: boolean; JIGYO_CD: number }>) => {
      // 全初期化
      for (const key in state) {
        const tempKey: keyof searchUserState = key as keyof searchUserState
        ;(state as any)[tempKey] = initialState[tempKey]
      }
      const payload = action.payload
      if (!payload.isSuper) {
        state.searchJoken.JIGYO_CD = payload.JIGYO_CD
      }
    },
    // 条件初期化 //===========================//
    format: (state) => {
      state.searchJoken = initialState.searchJoken
    },
    // 条件完全初期化 //===========================//
    formatAll: (state) => {
      for (const key in state) {
        const tempKey: keyof searchUserState = key as keyof searchUserState
        ;(state as any)[tempKey] = initialState[tempKey]
      }
    },
  },
})

// actionCreator 書き忘れないこと！
export const {
  changeJigyoCd, // 事業所変更
  changeMail, // メールアドレス変更
  changeInclideKari, // 仮登録ユーザーチェック変更
  changeTokuiCd, // 得意先変更
  changeTenCd, // 店舗変更
  initialize, // 初期状態に設定する処理
  format, // 条件初期化
  formatAll, // 条件完全初期化
} = searchUserSlice.actions
export default searchUserSlice.reducer
